export const EVENT_TYPES = [
  { id: '4', name: 'Cricket', slug: 'cricket' },
  { id: '1', name: 'Football', slug: 'football' },
  { id: '2', name: 'Tennis', slug: 'tennis' },
  { id: '7', name: 'horserace', slug: 'horseracing' },
  // { id: '4339', name: 'greyhound', slug: 'greyhoundracing' },
  // { id: '7522', name: 'Basketball', slug: 'basketball' },
  // { id: '7511', name: 'Baseball', slug: 'baseball' },
];

export const EXCH_SPORTS_MAP = {
  tennis: '2',
  football: '1',
  soccer: '1',
  cricket: '4',
  greyhound: '4339',
  Baseball: '7511',
  Basketball: '7522',
};
